import { FC } from 'react';
import InputMask from 'react-input-mask';
import { FormControl, FormHelperText, FormLabel, OutlinedInput } from '@mui/material';
import { withControl } from '@features/effector-form/hoc/withControl';
import i18n from '@shared/config/i18n';

const { t } = i18n;

const mask = `99 ${t('ShortDay')} 99 ${t('ShortHour')} 99 ${t('Min')}`;

const DurationMaskedInput: FC = (props) => (
  <InputMask mask={mask} maskPlaceholder="_" alwaysShowMask {...props} />
);

export const TicketTypeDurationControl = withControl(
  ({
    value,
    setValue,
    error,
    label,
    required,
    readOnly,
    disabled,
    isError,
    helperText,
  }) => (
    <FormControl required={required} disabled={disabled}>
      {label && <FormLabel error={isError}>{label}</FormLabel>}
      <OutlinedInput
        value={value}
        readOnly={readOnly}
        disabled={disabled}
        inputComponent={DurationMaskedInput}
        onChange={(e) => setValue(/\d/.test(e.target.value) ? e.target.value : '')}
        error={isError}
      />
      {error && <FormHelperText error>{error}</FormHelperText>}

      {!readOnly && helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  )
);
